import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Button from '../ui/Button';

const sections = [
  { label: 'Why', anchor: '#why' },
  { label: 'How', anchor: '#how' },
  { label: 'For you', anchor: '#for-you' },
  { label: 'Impact', anchor: '#impact' },
  { label: 'Projects', anchor: '#projects' },
];

export default function PublicNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const onLanding = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleAnchorClick = (e, anchor) => {
    e.preventDefault();
    if (onLanding) {
      document.querySelector(anchor)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/' + anchor);
    }
  };

  // Solid background once scrolled / when on a non-landing page. Transparent over the hero.
  const wrapperClass = scrolled || !onLanding
    ? 'border-b border-gray-200 bg-white/90 backdrop-blur'
    : 'border-b border-transparent bg-transparent';
  const linkColor = scrolled || !onLanding ? 'text-gray-700 hover:text-gray-900' : 'text-white/90 hover:text-white';
  const brandColor = scrolled || !onLanding ? 'text-green-800' : 'text-white';
  const subColor = scrolled || !onLanding ? 'text-gray-500' : 'text-green-300/80';

  return (
    <header className={`fixed left-0 right-0 top-0 z-30 transition-colors duration-300 ${wrapperClass}`}>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5">
        <Link to="/" className="flex items-center gap-3.5">
          <div className="h-14 w-14 flex-shrink-0 overflow-hidden sm:h-16 sm:w-16">
            <img src="/atharva-logo.png" alt="Atharva logo" className="h-full w-full object-contain" />
          </div>
          <div className="flex flex-col leading-none">
            <span className={`font-serif text-2xl font-bold tracking-tight sm:text-[1.75rem] ${brandColor}`}>
              Atharva
            </span>
            <span className={`mt-1 text-[11px] font-semibold uppercase tracking-[0.2em] ${subColor}`}>
              Sustainable Agritech
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          {sections.map((s) => (
            <a
              key={s.anchor}
              href={s.anchor}
              onClick={(e) => handleAnchorClick(e, s.anchor)}
              className={`text-sm font-medium transition-colors ${linkColor}`}
            >
              {s.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/login" className={`text-sm font-medium transition-colors ${linkColor}`}>
            Sign in
          </Link>
          <Link to="/signup">
            <Button size="sm">Get started</Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
